import React from 'react';
import { useMutation } from '@apollo/react-hooks';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { sha256 } from 'js-sha256';
import SetPassword from './components/SetPassword';
import resetPasswordMutation from './graphql/resetPassword.graphql';

export default observer(({ match }) => {
  const history = useHistory();

  const onError = (err) => toast.error(`${err}`);
  const onCompleted = () => {
    toast.success('Password has been reset !');
    history.push('/login');
  };

  const [resetPassword] = useMutation(resetPasswordMutation, {
    fetchPolicy: 'no-cache',
    onError,
    onCompleted,
  });

  const onSubmit = (data) => {
    resetPassword({ variables: { input: { newPassword: sha256(data.password), token: match.params.token } } });
  };


  return (
    <SetPassword onSubmit={onSubmit} />
  );
});
